import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { irvingtonConfig } from "./data";

export default function IrvingtonPage() {
  return <CityPageTemplate config={irvingtonConfig} />;
}